import React, { useContext } from 'react';
import ElipsisCell from '../../../../components/TableBox/Cells/EllipsisCell';
import Badge from '../../../../components/Badge';
import Button from '../../../../components/Button';
import { TableContext } from '../../../../contexts/TableContext';
import { RowClassName } from '../../../../enums';
import { VALIDATION_FIELD_MAPPING, TASK_PRIORITY_VARIANT, TASK_STATUS_VARIANT } from '../../../../utils/appConstant';
import { Task } from '../../../../interfaces/property-visit.interface';

interface RowProps {
  item: Task;
  className?: RowClassName;
  isEditable: boolean;
  onOpenEditTask: (task: Task) => void;
  onOpenDeleteTask: (taskId: string) => void;
}

const TaskRow: React.FC<RowProps> = ({ item, className, isEditable, onOpenEditTask, onOpenDeleteTask }) => {
  const { headCells } = useContext(TableContext);

  const actionsNode = (
    <div className="d-flex align-items-sm-center justify-content-sm-start">
      {isEditable && (
        <>
          <Button
            className="btn btn-sm btn-icon btn-text-secondary waves-effect waves-light rounded-pill"
            icon={<i className="ri-pencil-line ri-20px"></i>}
            onClick={() => onOpenEditTask(item)}
          />
          <Button
            className="btn btn-sm btn-icon btn-text-danger waves-effect waves-light rounded-pill"
            icon={<i className="ri-delete-bin-line ri-20px"></i>}
            onClick={() => onOpenDeleteTask(item.id)}
          />
        </>
      )}
    </div>
  );

  const isDone = item.status === 'done';
  const doneClass = isDone ? 'text-decoration-line-through text-muted' : '';

  return (
    <tr className={className}>
      {headCells.map((headCell) => {
        if (headCell.id === VALIDATION_FIELD_MAPPING.taskDescription) {
          return <ElipsisCell key={headCell.id} width={headCell.width} text={item.description} className={doneClass} />;
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.taskCategory) {
          return (
            <ElipsisCell
              key={headCell.id}
              width={headCell.width}
              text={item.category.charAt(0).toUpperCase() + item.category.slice(1)}
              className={doneClass}
            />
          );
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.taskPriority) {
          return (
            <td key={headCell.id} width={headCell.width}>
              <Badge
                text={TASK_PRIORITY_VARIANT[item.priority]?.label ?? item.priority}
                variant={(TASK_PRIORITY_VARIANT[item.priority]?.badge ?? 'secondary') as any}
              />
            </td>
          );
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.taskStatus) {
          return (
            <td key={headCell.id} width={headCell.width}>
              <Badge
                text={item.status_name || item.status}
                variant={(TASK_STATUS_VARIANT[item.status] ?? 'secondary') as any}
              />
            </td>
          );
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.taskDueDate) {
          return (
            <ElipsisCell
              key={headCell.id}
              width={headCell.width}
              text={item.due_date || '-'}
              className={doneClass}
            />
          );
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.actions) {
          return <td key={headCell.id} width={headCell.width}>{actionsNode}</td>;
        }
        return <ElipsisCell key={headCell.id} width={headCell.width} text={(item as any)[headCell.id] ?? '-'} />;
      })}
    </tr>
  );
};

export default TaskRow;
